/* eslint-disable no-unused-vars */
import React from "react";
import { FormHelperText } from "@mui/material";
import {
  ICredentialsRapiboyPayload,
  ICredentialsRapiboy,
  ICredentialsOcasaPayload,
  ICredentialsOcasa,
  ICarrier,
  ICarriersChanges,
  IOwnLogisticsMatrix,
  IFallbackQuotation,
} from "../interfaces/configuration";
import {
  ERRORS_MESSAGES,
  MATRIX_CSV_MAX_SIZE_BYTES,
  OCA,
  OCASA,
  RAPIBOY,
} from "./constants";
import { TEntity } from "../interfaces/userContext";
import { postCarriersChanges } from "../requests/carrierRequests";

// TODO PASAR ESTA FUNCION A UN ARCHIVO GENERAL (SE USA EN MUCHOS COMPONENTES)
export const showInputErrors = (inputErrors: string[] = []) =>
  inputErrors.map((message: string) => (
    <FormHelperText className="color-error" key={message}>
      {message}
    </FormHelperText>
  ));

const genericCredentialsChanged = (
  credentials: any,
  newCredentials: any
): boolean => {
  const keys = Object.keys(newCredentials);

  console.info("Keys", keys);

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (key === "extended_week")
      console.info(
        "Extended week log",
        credentials.extended_week,
        newCredentials.extended_week
      );

    if (
      key !== "expired" &&
      String(credentials[key]) !== String(newCredentials[key])
    )
      return true;
  }

  return false;
};

const ocasaRapiboyCredentialsChanged = (
  credentials: ICredentialsRapiboyPayload,
  newCredentials: ICredentialsRapiboy
): boolean => {
  const parsedCredentials = {
    ...credentials,
    dimensions: credentials?.dimensions,
  };

  return genericCredentialsChanged(parsedCredentials, newCredentials);
};

export const credentialHasChanges = (
  olName: string,
  credentials: any,
  newCredentials: any
): boolean => {
  switch (olName) {
  case OCA:
    return genericCredentialsChanged(credentials, newCredentials);
  case RAPIBOY:
    return ocasaRapiboyCredentialsChanged(credentials, newCredentials);
  default:
    return false;
  }
};

export const getFormDataFromCarriersInfo = (
  carriersChanges: ICarriersChanges,
  entity: TEntity,
  selectedMarketplace?: string
) => {
  const formData = new FormData();
  const carriersToUpdate: any[] = [];

  Object.entries(carriersChanges).forEach(([key, values]) => {
    const credentials: any = values.credentials || {};

    if (credentials?.matrix)
      formData.append(`matrix_${key}`, credentials.matrix);

    // Limpiar credentials: quitar 'matrix' y atributos falsy
    const cleanedCredentials = Object.fromEntries(
      Object.entries(credentials).filter(
        ([innerKey, value]) => innerKey !== "matrix" && value !== undefined
      )
    );

    carriersToUpdate.push({
      ...values,
      credentials: {
        ...cleanedCredentials,
      },
    });
  });

  formData.append("carriers", JSON.stringify(carriersToUpdate));
  return postCarriersChanges({
    formData,
    selectedMarketplace,
    entity,
  });
};

export const getFormDataFromCarriersList = (
  carriersChanges: ICarrier[],
  entity: TEntity,
  selectedMarketplace?: string
) => {
  const formData = new FormData();
  const mappedCarriers = carriersChanges.map(
    ({ credentials, name, ...rest }) => {
      formData.append(`matrix_${name}`, credentials?.matrix);

      return {
        credentials,
        name,
        ...rest,
      };
    }
  );

  formData.append("carriers", JSON.stringify(mappedCarriers));

  return postCarriersChanges({
    formData,
    selectedMarketplace,
    entity,
  });
};

export const validateMatrixFile = (file: File): string[] => {
  const errors: string[] = [];

  if (!file.name.toLowerCase().endsWith(".csv"))
    errors.push(ERRORS_MESSAGES.matrixInvalidExtension);

  if (file.size > MATRIX_CSV_MAX_SIZE_BYTES)
    errors.push(ERRORS_MESSAGES.matrixFileTooLarge);

  return errors;
};

export const getOwnFleetMatricesToShow = (matrices: IOwnLogisticsMatrix[]) => {
  if (!matrices || !matrices.length) return [];

  // Sort by descending order
  const sortedMatrices = [...matrices].sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );
  const lastMatrix = sortedMatrices[0];

  // Return only last matrix
  return lastMatrix ? [lastMatrix] : [];
};

const hasMoreThanTwoDecimals = (value: number) => {
  return !/^\d+(\.\d{0,2})?$/.test(value.toString());
};

export const validateFallbackQuotes = (
  fallbackQuotation: IFallbackQuotation,
) => {
  const errors: {
    [key: number]: { fee?: string[] };
  } = {};

  ([50, 120, 200, 250] as const).forEach((weight) => {
    const range = fallbackQuotation.ranges[weight];

    if (range.fee === undefined) {
      if (!errors[weight]) errors[weight] = {};
      errors[weight].fee = ["El costo es requerido"];
    } else {
      if (range.fee < 0) {
        if (!errors[weight]) errors[weight] = {};
        errors[weight].fee = ["El costo debe ser positivo"];
      } else if (hasMoreThanTwoDecimals(range.fee)) {
        if (!errors[weight]) errors[weight] = {};
        errors[weight].fee = ["El costo debe tener máximo 2 decimales"];
      }
    }
  });

  return errors;
};

